import useListRowInfStroe from "store/listRowInf";
import { FormEvent, useRef } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  rmAdCreateApi,
  rmCrateApi,
  rmInfApi,
  rmModifyApi,
} from "components/api/rm";
import useAlertStore from "store/alert";
import useLodStore from "store/lod";
import i18n from "locales/i18n";
import useMultiLangStore from "store/multiLang";
import { useRoomAddInfContext } from "./context";
import { IRmAdInf, IRmImg, IRmInf } from "interface/rm/rm";
import useModalStore from "store/modal";
import { apifield, updated, getFormData } from "components/utils/comm";

type IGetData = {
  modalNm: string;
};
// 상세정보 조회
export const useGetData = ({ modalNm }: IGetData) => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);

  const baseInfRef = useRef<IRmInf | null>(null);
  const addInfRef = useRef<IRmAdInf[]>([]);
  const imgLitRef = useRef<IRmImg[]>([]);

  const { data } = useQuery({
    queryKey: ["room-detail", listRowInf.btnNm],
    placeholderData: {
      baseInf: baseInfRef.current,
      addInf: addInfRef.current,
      imgList: imgLitRef.current,
    },

    queryFn: () => {
      return rmInfApi({ rmNo: listRowInf.no });
    },
    select: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          baseInfRef.current = data.rmDtl;
          addInfRef.current = data.rmAddInfList;
          imgLitRef.current = data.rmImgList;
        }
        if (code === -1) {
          apifield(message);
        }
        return res;
      }
    },

    enabled: !!listRowInf.no && listRowInf.btnNm === modalNm,
  });

  // const mutation = useMutation({
  //   mutationKey: ["room-detail", params],
  //   mutationFn: rmInfApi,
  //   onSuccess: (res) => {
  //     if (res) {
  //       const {
  //         status: { code, message },
  //         data,
  //       } = res;
  //       if (code === 0) {
  //         setBaseInf(data.rmDtl);
  //         setAddInf(data.rmAddInfList);
  //         setImgList(data.rmImgList);
  //         setIsSuccess(false);
  //       }
  //       if (code === -1) {
  //         apifield(message);
  //       }
  //     }
  //   },
  // });

  // useEffect(() => {
  //   if (params.rmNo && listRowInf.btnNm === modalNm) {
  //     mutation.mutate(params);
  //   }
  // }, [params.rmNo, modalNm]);

  // useEffect(() => {
  //   if (isSuccess) {
  //     mutation.mutate(params);
  //   }
  // }, [isSuccess]);

  return {
    baseInf: baseInfRef.current,
    addInf: addInfRef.current,
    imgList: imgLitRef.current,
  };
};

// 기본정보 등록
export const useBaseCreateMutate = () => {
  const setListRowParams = useListRowInfStroe(
    (state) => state.setListRowParams
  );
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const onSetStyles = useModalStore((state) => state.onSetStyles);
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["room-base-inf-create"],
    mutationFn: rmCrateApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          //
          onSetAlert({
            isOpen: true,
            inner: "객실기본정보를 생성하였습니다.",
            onSetConfirm: () => {
              queryClient.invalidateQueries({
                queryKey: ["room-detail", listRowInf.btnNm],
              });
              onSetStyles("w-full");
              setListRowParams({
                rgSeq: 1,
                no: data.rmNo,
                btnNm: "create",
              });
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

//기본정보 수정
export const useBaseUpdateMutate = () => {
  const queryClient = useQueryClient();
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  return useMutation({
    mutationKey: ["room-base-inf-update"],
    mutationFn: rmModifyApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 기본정보 수정
          onSetAlert({
            isOpen: true,
            inner: "기본정보 수정을 완료하였습니다.",
            onSetConfirm: () => {
              queryClient.invalidateQueries({
                queryKey: ["room-detail", listRowInf.btnNm],
              });
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

export const useBaseSubmitForm = () => {
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const lod = useLodStore((state) => state.lod);
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { mutate: updateMutate } = useBaseUpdateMutate();
  const { mutate: createMutate } = useBaseCreateMutate();

  const onBaseSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const { type } = form.dataset;

    // 기본정보 생성
    if (type === "create") {
      const params = getFormData({ form, type: "C" });
      /**
       * 필수값 입력 확인 : 긱실전망, 갤실타입, 침대종류, 최대인원수
       */
      const isAble =
        params.rmTypCd && params.rmOlkCd && params.maxPerCt && params.bedTypCd;

      if (!isAble) {
        return onSetAlert({
          isOpen: true,
          inner: "필수입력값을 입력하여 주세요.",
        });
      }
      if (!!isAble) {
        // 기본정보 생성
        onSetAlert({
          isOpen: true,
          inner: "기본정보를 생성하시겠습니까?",
          cnclBtn: true,
          onSetConfirm: () => {
            createMutate({
              lodNo: lod?.lodNo,
              ...params,
            });
          },
        });
      }
    }

    // 기본정보 수정
    if (type === "update") {
      const isUpdate = updated({ form });
      if (isUpdate) {
        onSetAlert({
          isOpen: true,
          inner: "내용을 수정하시겠습니까?",
          cnclBtn: true,
          onSetConfirm: () => {
            // 수정 api
            const params = getFormData({ form, type: "U" });

            updateMutate({
              ...params,
              rmNo: listRowInf.no,
              lodNo: lod?.lodNo,
              langCd: i18n.language,
            });
          },
        });
      }
    }
  };

  return {
    onBaseSubmit,
  };
};

// 추가정보 수정
export const useAddInfUpdateMutate = () => {
  const queryClient = useQueryClient();
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const resetMultiLang = useMultiLangStore((state) => state.resetMultiLang);
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { resetDefaultValue } = useRoomAddInfContext();
  return useMutation({
    mutationKey: ["room-addinf-update"],
    mutationFn: rmModifyApi,
    onSuccess: (res, variables) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 수정 완료후 상세조회, button reset
          onSetAlert({
            isOpen: true,
            inner: "추가정보 수정 완료하였습니다.",
            onSetConfirm: () => {
              resetMultiLang();
              resetDefaultValue(variables?.langCd);
              queryClient.invalidateQueries({
                queryKey: ["room-detail", listRowInf.btnNm],
              });
            },
          });
        }
        if (code == -1) {
          apifield(message);
        }
      }
    },
  });
};

// 추가정보 등록
export const useAddInfCreateMutate = () => {
  const queryClient = useQueryClient();
  const listRowInf = useListRowInfStroe((state) => state.listRowInf);
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const resetMultiLang = useMultiLangStore((state) => state.resetMultiLang);
  const { resetDefaultValue } = useRoomAddInfContext();
  return useMutation({
    mutationKey: ["room-add-inf-create"],
    mutationFn: rmAdCreateApi,
    onSuccess: (res, variables) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 데이터 조회 여부
          onSetAlert({
            isOpen: true,
            inner: "추가정보를 등록하였습니다.",
            onSetConfirm: () => {
              resetMultiLang();
              resetDefaultValue(variables.rmAddInfList[0].langCd);
              queryClient.invalidateQueries({
                queryKey: ["room-detail", listRowInf.btnNm],
              });
              // 등록된 언어 제외
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};

export const useAddInfSubmitForm = () => {
  const { listRowInf } = useListRowInfStroe();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const { mutate: updateMutate } = useAddInfUpdateMutate();
  const { mutate: careateMutate } = useAddInfCreateMutate();
  const { getDefaultValue } = useRoomAddInfContext();
  const lod = useLodStore((state) => state.lod);

  const onAddInfSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const { type } = form.dataset;
    const langcd = form.id.replace(/^.*-/, "") || i18n.language;

    const data = getDefaultValue(langcd ?? "");
    // 추가정보 등록
    if (type === "create") {
      if (!listRowInf.no) {
        return onSetAlert({
          isOpen: true,
          inner: "객실 기본정보를 먼저 생성하여 주세요.",
        });
      }

      let param = getFormData({ form, type: "C" });

      param = {
        ...param,
        ...data,
      };

      if (!(param.rmNm && param.rmDesc)) {
        return onSetAlert({
          isOpen: true,
          inner: "필수값을 입력하여 주세요.",
        });
      }

      if (!!(param.rmNm && param.rmDesc)) {
        const params = {
          rmNo: listRowInf.no,
          rmAddInfList: [
            {
              langCd: langcd,
              rmNo: listRowInf.no,
              ...param,
            },
          ],
        };

        // 추가정보 등록
        onSetAlert({
          isOpen: true,
          inner: "추가정보를 등록하시겠습니까?",
          cnclBtn: true,
          onSetConfirm: () => {
            careateMutate(params);
          },
        });
      }
      return;
    }

    // 추가정보 수정
    if (type === "update") {
      const isUpdate =
        updated({ form }) ||
        Object.values(data).some(
          (data) => data !== "" && data !== null && data !== undefined
        );

      // 수정된 내용이 없음
      if (!isUpdate) {
        return onSetAlert({
          isOpen: true,
          inner: "수정된 내용이 없습니다.",
        });
      }

      // 수정된 내용이 있음
      if (isUpdate) {
        onSetAlert({
          isOpen: true,
          inner: "추가내용을 수정하시겠습니까?",
          cnclBtn: true,
          onSetConfirm: () => {
            const params = getFormData({ form, type: "U" });

            updateMutate({
              ...params,
              ...data,
              langCd: langcd,
              rmNo: listRowInf.no,
              lodNo: lod?.lodNo,
            });
          },
        });
      }
    }
  };

  return {
    onAddInfSubmit,
  };
};
